import { render } from "./FormLabel.vue?vue&type=template&id=0508d763"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"
script.render = render

export default script